import { Typography } from '@mui/material';
import type { Account } from '@repo/api-gw-sdk';

import { useDAL } from '@/contexts/useDAL';

export const RestoreAccountConfiguration = ({
  account,
}: {
  account: Account;
}) => {
  const dal = useDAL();
  // this will be changed with the new UI, as we won't have one column indication for multiple props.
  // today this custom indicate if there is a change in both tags and network.
  const { body: accountConfigurationsBody } =
    dal.cloudAccounts.restore.configuration.list();
  const config = accountConfigurationsBody?.find(
    (x) => x.cloudAccountId === account.id
  );
  return <Typography>{config ? 'Custom' : 'Default'}</Typography>;
};
